import React, {useEffect, useState} from "react";
import cx from "classnames";
import {useLocation} from "react-router-dom";

import {CircularProgress} from "@mui/material";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import Header from "./components/header/Header";
import Search from "./components/search/Search";
import Tag from "../../components/tag/Tag";
import PaginationBlog from "./components/pagination/Pagination";

import OtherArticles from "../../components/other-articles/OtherArticles";
import RequestModal from "../../components/modal/RequestModal";

import {
    useArticles, useArticlesCount,
    useArticlesParams,
    useLazyGetArticlesQuery,
    useLazyGetTagsQuery,
    useTags
} from "../../api/blog";

import {INITIAL_DATA_REQUEST} from "../../constants";

import styles from "./Blog.module.scss";

function Blog () {

    const [open, setOpen] = React.useState(false);

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    const [value, setValue] = useState('');

    const defaultArticles = useArticles().results;

    const defaultTags = useTags();

    const [ articlesRequest, { data: articles, isFetching } ] = useLazyGetArticlesQuery()

    const [ tagsRequest, { data: tags } ] = useLazyGetTagsQuery()

    const articlesParams = useArticlesParams();

    const articlesCount = useArticlesCount();

    const location = useLocation();

    const categoryFromState = location.state?.category;

    useEffect(() => {

        const fetchArticlesAndTags = () => {
            articlesRequest({
                ...INITIAL_DATA_REQUEST,
                ...(categoryFromState && { category: categoryFromState }),
            });
        };

        fetchArticlesAndTags();

        !defaultTags.length && tagsRequest({});
    }, [articlesRequest, categoryFromState, defaultTags.length, tagsRequest]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const onSearchRequest = async (query) => {
        const result = await articlesRequest({
            ...INITIAL_DATA_REQUEST,
            category: undefined,
            search: query,
        })

        const articles = result.data?.data ?? [];

        const articleIds = articles.map((article) => article.id);

        if (articleIds.length > 0) {
            tagsRequest({ articleIds });
        }
    }

    const onUpdateRequest = (params) => {
        return articlesRequest({...articlesParams, ...params});
    }

    const handleClickAll = () => {
        articlesRequest({
            ...INITIAL_DATA_REQUEST,
            category: undefined,
        });
    }

    const totalArticles = articles?.meta.pagination.total;

    const onChange = (value) => {
        setValue(value);
    }

    return (
        <>
            <div className={styles.blog}>
                <Header handleOpen={handleOpen}/>
                <Search onSearch={onSearchRequest} setValue={onChange} value={value}/>
                <Container>
                    {isFetching ?
                        <div className={styles.loaderContainer}>
                            <CircularProgress size={isMobile ? 24 : 40} />
                        </div> : <Row className={styles.content}>
                        <Col xxl={8} className={cx(styles.articleList, {
                            [styles.articleListBlog]: value,
                        })} >
                            <OtherArticles articles={defaultArticles || articles} value={value}/>
                        </Col>
                        {articles && <Col xxl={4} className={styles.tagsContainer}>
                                <div className={cx(styles.tags, {
                                    [styles.tagsSearch]: value,
                                })}>
                                    <Tag
                                        slug='all'
                                        isActive={!articlesParams.category}
                                        count={totalArticles}
                                        onClick={handleClickAll}
                                    >Все</Tag>
                                    {(defaultTags || tags)?.map((tag, index) => (
                                        <Tag
                                            key={tag.id}
                                            slug={tag.slug}
                                            count={tag.articles.length}
                                            isActive={articlesParams.category === tag.slug}
                                        >{tag.name}</Tag>
                                    ))}
                                </div>
                            </Col>}
                    </Row>}
                </Container>
                {!isFetching && articlesCount > 5 && <PaginationBlog onUpdate={onUpdateRequest}/>}
                <Row>
                    <Col xs={12} className='p-0'>
                        <h5 className={styles.companyName}>© 2026 Вэдмаркет</h5>
                    </Col>
                </Row>
            </div>
            <RequestModal open={open} handleClose={handleClose}/>
        </>
    );
}

export default Blog
